import { cn } from '../../lib/cn';

export default function MultipleChoice({
  options,
  value,
  onChange,
  name,
  disabled = false,
  className,
}) {
  // Normalize options: can be array of strings OR array of {key, text} objects
  const normalizedOptions = options.map((opt, index) => {
    if (typeof opt === 'string') {
      return { key: String.fromCharCode(65 + index), text: opt, value: opt };
    }
    return { key: opt.key, text: opt.text, value: opt.key };
  });

  return (
    <div className={cn('space-y-3', className)}>
      {normalizedOptions.map((option, index) => {
        const isSelected = value === option.value;
        const optionId = `${name}-option-${index}`;

        return (
          <label
            key={index}
            htmlFor={optionId}
            className={cn(
              'flex items-start gap-4 p-4 rounded-lg',
              'border-2 transition-all duration-200 cursor-pointer',
              isSelected
                ? 'border-gray-900 dark:border-white bg-gray-50 dark:bg-gray-800'
                : 'border-gray-200 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500 hover:bg-gray-50/50 dark:hover:bg-gray-800/50',
              disabled && 'opacity-60 cursor-not-allowed'
            )}
          >
            <input
              type="radio"
              id={optionId}
              name={name}
              value={option.value}
              checked={isSelected}
              onChange={() => onChange(option.value)}
              disabled={disabled}
              className="sr-only"
            />
            <span
              className={cn(
                'flex-shrink-0 w-8 h-8 rounded-lg',
                'flex items-center justify-center text-sm font-semibold transition-all duration-200',
                isSelected
                  ? 'bg-gray-900 dark:bg-white text-white dark:text-gray-900'
                  : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300'
              )}
            >
              {option.key}
            </span>
            <span
              className={cn(
                'text-gray-700 dark:text-gray-200 leading-relaxed pt-1',
                isSelected && 'text-gray-900 dark:text-white font-medium'
              )}
            >
              {option.text}
            </span>
          </label>
        );
      })}
    </div>
  );
}

export function MultipleChoiceWithLetters({
  options,
  value,
  onChange,
  name,
  disabled = false,
  className,
}) {
  const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

  return (
    <div className={cn('space-y-3', className)}>
      {options.map((option, index) => {
        const isSelected = value === option;
        const optionId = `${name}-option-${index}`;
        const letter = letters[index] || String(index + 1);

        return (
          <label
            key={index}
            htmlFor={optionId}
            className={cn(
              'flex items-start gap-4 p-4 rounded-lg',
              'border-2 transition-all duration-200 cursor-pointer',
              isSelected
                ? 'border-gray-900 dark:border-white bg-gray-50 dark:bg-gray-800'
                : 'border-gray-200 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500 hover:bg-gray-50/50 dark:hover:bg-gray-800/50',
              disabled && 'opacity-60 cursor-not-allowed'
            )}
          >
            <input
              type="radio"
              id={optionId}
              name={name}
              value={option}
              checked={isSelected}
              onChange={() => onChange(option)}
              disabled={disabled}
              className="sr-only"
            />
            <span
              className={cn(
                'flex-shrink-0 w-8 h-8 rounded-lg',
                'flex items-center justify-center',
                'text-sm font-semibold transition-all duration-200',
                isSelected
                  ? 'bg-gray-900 dark:bg-white text-white dark:text-gray-900'
                  : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300'
              )}
            >
              {letter}
            </span>
            <span
              className={cn(
                'text-gray-700 dark:text-gray-200 leading-relaxed pt-1',
                isSelected && 'text-gray-900 dark:text-white'
              )}
            >
              {option}
            </span>
          </label>
        );
      })}
    </div>
  );
}
